import React from "react";
import { imageBasePath } from "../../Utils/config";

const Footer = () => {
  return (
    <footer>
      <p className="caption">©2019 SILC - All rights reserved</p>
      <img src={imageBasePath + "bx_bx-right-arrow-alt.png"} alt="card1arrowimage" />
    </footer>
  );
};

export default Footer